/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

/**
 * Internal dependencies.
 */
import './src/fonts/fonts.css';

/**
 * On client entry.
 *
 * @return {void}
 */
export const onClientEntry = () => {
	window.onload = () => document.documentElement.classList.add('app-loaded');

	// Simple, focused print button function with extensive logging
	console.log('🚀 Gatsby onClientEntry started - looking for print button...');

	const initPrintButton = () => {
		console.log('🔍 initPrintButton function called');
		console.log('📄 Document ready state:', document.readyState);

		// Look for the specific button
		const printButton = document.getElementById('print-here');
		console.log('🔘 Print button found:', printButton);

		if (printButton) {
			console.log('✅ Button found! Adding click listener...');
			console.log('🔘 Button details:', {
				id: printButton.id,
				className: printButton.className,
				tagName: printButton.tagName,
				textContent: printButton.textContent
			});

			printButton.addEventListener('click', function (event) {
				console.log('🎯 PRINT BUTTON CLICKED!');
				console.log('📋 Event details:', event);

				// Prevent default behavior
				event.preventDefault();
				console.log('🚫 Default prevented');

				// Open print dialog
				console.log('🖨️ Opening print dialog...');
				window.print();
				console.log('✅ Print dialog should be open now');
			});

			console.log('✅ Click listener added successfully');
		} else {
			console.warn('❌ Button with id "print-here" NOT FOUND');
			console.log('🔍 Available elements with IDs:', Array.from(document.querySelectorAll('[id]')).map(el => el.id));
		}
	};

	// Try to initialize immediately
	console.log('⚡ Attempting immediate initialization...');
	initPrintButton();

	// Also try when DOM is ready
	if (document.readyState === 'loading') {
		console.log('⏳ DOM still loading, adding DOMContentLoaded listener...');
		document.addEventListener('DOMContentLoaded', () => {
			console.log('📋 DOMContentLoaded fired - trying again...');
			initPrintButton();
		});
	} else {
		console.log('✅ DOM already ready');
	}

	// Also try after a short delay as backup
	setTimeout(() => {
		console.log('⏰ Timeout backup - trying one more time...');
		initPrintButton();
	}, 1000);

	/**
	 * Polyfill jQuery for hubspot form and provide only what it needs since its script uses jQuery on form submit.
	 * Hoping that there would a truly React component available for hubspot in future and we can remove the below code.
	 */
	window.jQuery = window.jQuery || function (selector) {
		const form = 'string' === selector ? document.querySelector(selector) : selector;

		return {
			serializeArray: function () {
				var arr = [];

				Array.prototype.slice.call(form.elements).forEach(function (field) {
					if (!field.name || field.disabled || ['file', 'reset', 'submit', 'button'].indexOf(field.type) > -1) return;
					if (field.type === 'select-multiple') {
						Array.prototype.slice.call(field.options).forEach(function (option) {
							if (!option.selected) return;
							arr.push({
								name: field.name,
								value: option.value
							});
						});

						return;
					}

					if (['checkbox', 'radio'].indexOf(field.type) > -1 && !field.checked) return;

					arr.push({
						name: field.name,
						value: field.value
					});
				});

				return arr;
			}
		};
	};
}

export { wrapRootElement } from './src/apollo/wrap-root-element';
